const initState = {
    authError: null
};

const notesReducer = (state = initState, action) => {
   return state;
}

export default notesReducer